import { createRouter, createWebHistory } from 'vue-router';
import authService from '@/auth/authService';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { guestOnly: true },
  },
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/europace-callback',
    name: 'europace-callback',
    component: () => import('@/views/EuropaceCallbackView.vue'),
    meta: { requiresAuth: false }, // Allow without auth since we're in OAuth flow
  },
  {
    path: '/fincrm-callback',
    name: 'fincrm-callback',
    component: () => import('@/views/FincrmCallbackView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminPanelView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!authService.state.initialized && !authService.state.loading) {
    await authService.init();
  }

  if (to.meta.requiresAuth && !authService.state.authenticated) {
    return next({
      name: 'login',
      query: { redirect: to.fullPath },
    });
  }

  if (to.meta.requiresRole && !authService.hasRealmRole(to.meta.requiresRole)) {
    return next({ path: '/' });
  }

  if (to.meta.guestOnly && authService.state.authenticated) {
    return next({ path: to.query.redirect || '/' });
  }

  return next();
});

export default router;
